import { render, staticRenderFns } from "./NavBarItem.vue?vue&type=template&id=f052270c&scoped=true&"
import script from "./NavBarItem.vue?vue&type=script&lang=js&"
export * from "./NavBarItem.vue?vue&type=script&lang=js&"
import style0 from "./NavBarItem.vue?vue&type=style&index=0&id=f052270c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f052270c",
  null
  
)

export default component.exports